let transitioning = false;

export class IdentityTransitionError extends Error {
    constructor() {
        super('Identity transition in progress');
        this.name = 'AbortError';
        this.code = 'IDENTITY_TRANSITION';
    }
}

export function beginIdentityTransition() { transitioning = true; }
export function endIdentityTransition() { transitioning = false; }
export function isIdentityTransitioning() { return transitioning; }
